import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import './assets/style/index.scss';
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import Vuex from 'vuex'
import scroll from 'vue-seamless-scroll'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.use(scroll)
Vue.use(Vuex)
Vue.prototype.$axios = axios
Vue.config.productionTip = false;
Vue.use(ElementUI);

/* 引入swiper */
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (<= Swiper 5.x)
// import 'swiper/css/swiper.css'

// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


// axios.defaults.timeout = 5000 // 请求超时
// axios.defaults.baseURL = 'http://127.0.0.1:8081' // api 即上面 vue.config.js 中配置的地址
//axios.defaults.baseURL = 'http://47.108.119.11:8081'  // api 即上面 vue.config.js 中配置的地址/
axios.defaults.baseURL = 'http://47.108.149.234:8081'  // api 即上面 vue.config.js 中配置的地址/

// router.beforeEach((to, from, next) => {
//   window.document.title = '成都市消毒协会'
//   if (to.meta.requireAuth) {
//     let token = Cookies.get('access_token');
//     if (token) {
//       next({
//         path: '/',
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   }
//   next();
// })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
